import { render, staticRenderFns } from "./PlacolderCard.vue?vue&type=template&id=54bd48a2&"
import script from "./PlacolderCard.vue?vue&type=script&lang=ts&"
export * from "./PlacolderCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlacolderCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports